import { NgModule } from '@angular/core';
import { AccordionModule } from 'primeng/accordion';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { CardModule } from 'primeng/card';
import { ChartModule } from 'primeng/chart';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { EditorModule } from 'primeng/editor';
import { InplaceModule } from 'primeng/inplace';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { MessageModule } from 'primeng/message';
import { MultiSelectModule } from 'primeng/multiselect';
import { PopoverModule } from 'primeng/popover';
import { PanelModule } from 'primeng/panel';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SpeedDialModule } from 'primeng/speeddial';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TableModule } from 'primeng/table';
import { TabsModule } from 'primeng/tabs';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { TreeModule } from 'primeng/tree';

@NgModule({
	imports: [
		AccordionModule,
		AutoCompleteModule,
		BadgeModule,
		ButtonModule,
		DatePickerModule,
		CardModule,
		ChartModule,
		ConfirmDialogModule,
		DialogModule,
		SelectModule,
		DynamicDialogModule,
		EditorModule,
		InplaceModule,
		InputTextModule,
		MenuModule,
		MessageModule,
		MultiSelectModule,
		PopoverModule,
		PanelModule,
		ProgressBarModule,
		ProgressSpinnerModule,
		ScrollPanelModule,
		SelectButtonModule,
		SpeedDialModule,
		SplitButtonModule,
		TabsModule,
		TableModule,
		ToastModule,
		ToolbarModule,
		TooltipModule,
		TreeModule,
	],
	exports: [
		AccordionModule,
		AutoCompleteModule,
		BadgeModule,
		ButtonModule,
		DatePickerModule,
		CardModule,
		ChartModule,
		ConfirmDialogModule,
		DialogModule,
		SelectModule,
		DynamicDialogModule,
		EditorModule,
		InplaceModule,
		InputTextModule,
		MenuModule,
		MessageModule,
		MultiSelectModule,
		PopoverModule,
		PanelModule,
		ProgressBarModule,
		ProgressSpinnerModule,
		ScrollPanelModule,
		SelectButtonModule,
		SpeedDialModule,
		SplitButtonModule,
		TabsModule,
		TableModule,
		ToastModule,
		ToolbarModule,
		TooltipModule,
		TreeModule,
	],
	providers: [MessageService, ConfirmationService],
})
export class NGPrimeModule {}
